import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BackLink = ({ to, show, history, text, changedRoute, onClick }) => {
  const ArrowIcon = <FontAwesomeIcon icon="arrow-left" size="2x" />

  if (!changedRoute && !show) return null

  return (
    <div
      className="link-back"
      onClick={() => onClick || (!to && history.goBack())}
    >
    {
        to ?
          <Link to={to}>
            {ArrowIcon} {text}
          </Link>
        :
          ArrowIcon
      }
    </div>
  )
}

BackLink.defaultProps = {
  to: '',
  text: '',
  changedRoute: false,
  show: false,
  onClick: null,
}

BackLink.propTypes = {
  history: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  changedRoute: PropTypes.bool,
  show: PropTypes.bool,
  text: PropTypes.string,
}

const enhance = compose(
  withRouter,
  connect(state => ({
    changedRoute: state.app.changedRoute,
  }), { }),
)

export default enhance(BackLink)



// WEBPACK FOOTER //
// ./src/browser/components/BackLink.js